import { Box } from '@chakra-ui/react';
import { Table as ReactTable } from '@tanstack/react-table';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import {
  createInitialColumnVisibility,
  PortfolioOverviewFacilityRow,
  stickyColumnHeaderId,
} from './PortfoliioOverviewFacilitiesTableUtils';
import { IsolatedMultiSelect } from 'packages/common-frontend/components/MultiSelect';

export const PortfolioOverviewFacilitiesColumnSelector: React.FC<{
  tableInstance: ReactTable<PortfolioOverviewFacilityRow>;
}> = ({ tableInstance }) => {
  const onApplyOptions = (selectedOptions: string[]) => {
    const updatedVisibleColumns = createInitialColumnVisibility(
      selectedOptions,
    );

    tableInstance.setColumnVisibility(updatedVisibleColumns);
  };

  const options = _.compact(
    _.map(tableInstance.getAllLeafColumns(), (column) => {
      // we do not want to list the sticky header column as an option to remove from the table
      // since this column is the anchor for the row
      if (column.id === stickyColumnHeaderId) {
        return undefined;
      }
      // in the case where the column header (headerKey) and id (accessorKey) differ
      const header = column.columnDef.header ?? column.id;
      return {
        label: commonUtils.toSentenceCase(
          typeof header === 'string' ? header : '',
        ),
        value: column.id,
      };
    }),
  );

  return (
    <Box w="228px" h="44px">
      <IsolatedMultiSelect
        options={options}
        initialSelections={_.compact(
          _.map(tableInstance.getAllLeafColumns(), (column) => {
            return column.getIsVisible() ? column.id : null;
          }),
        )}
        onApplyOptions={onApplyOptions}
        optionsHeader="Property"
        titleText="Show/Hide Columns"
        applyButtonText="Display selected columns"
        colorScheme="aurora"
        borderWidth="medium"
      />
    </Box>
  );
};
